import { render, staticRenderFns } from "./ModalCoinRecord.vue?vue&type=template&id=29da10ea&scoped=true&"
import script from "./ModalCoinRecord.vue?vue&type=script&lang=js&"
export * from "./ModalCoinRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModalCoinRecord.vue?vue&type=style&index=0&id=29da10ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da10ea",
  null
  
)

export default component.exports